import { Button, Card, TextField, Typography } from "@mui/material";
import React, { useMemo, useState } from "react";
import GModal from "../../../components/Modal";
import useCronKeyCheck from "../../../hooks/useCronKeyCheck";
import {
  StyledCronSetupContent,
  StyledCronSetupModalContent,
  StyledCronSetupText,
  StyledTextLink,
} from "./styles";
import { showErrors } from "../../../utils/ui";
import { setCronJobApiKey } from "../../../adapters";
import { toast } from "react-toastify";
import { setCronApiKeyState } from "../../../config/redux/slices/userSlice";
import { useDispatch } from "react-redux";

const CronSetupDetails = () => {
  const dispatch = useDispatch();
  const isSetup = useCronKeyCheck();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [enteredApiKey, setEnteredApiKey] = useState("");
  const [processing, setProcessing] = useState(false);

  const isKeyValid = useMemo(
    () => enteredApiKey.trim() && enteredApiKey.trim().length >= 20,
    [enteredApiKey]
  );

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => {
    setEnteredApiKey("");
    setIsModalOpen(false);
  };

  const onUpdate = async () => {
    if (!isKeyValid || processing) return;
    setProcessing(true);
    try {
      await setCronJobApiKey(enteredApiKey);
      dispatch(setCronApiKeyState(true));
      closeModal();
      toast.success("Api key updated.");
    } catch (e) {
      showErrors(e);
    }
    setProcessing(false);
  };
  return (
    <Card variant="outlined">
      <StyledCronSetupContent>
        <StyledCronSetupText>
          <Typography variant="body2">Cron Job API Key</Typography>
          <Typography variant="caption" color="textSecondary">
            {isSetup ? "Your api key is active." : "Not set."}
          </Typography>
        </StyledCronSetupText>
        <Button variant="outlined" size="small" onClick={openModal}>
          {isSetup ? "Update" : "Add"}
        </Button>
      </StyledCronSetupContent>
      <GModal
        isOpen={isModalOpen}
        onClose={closeModal}
        title="Set your new api key"
        closeOnOutsideClick={!processing}
        closeOnEscape={!processing}
        loading={processing}
        primaryButton={{
          text: isSetup ? "Update" : "Add",
          color: "success",
          onClick: onUpdate,
          size: "medium",
          disabled: !isKeyValid,
          loading: processing,
        }}
        secondaryButton={{
          text: "Cancel",
          color: "secondary",
          onClick: closeModal,
          size: "medium",
          disabled: processing,
        }}
      >
        <StyledCronSetupModalContent>
          <Typography variant="body1" color="textPrimary">
            Get your API key from{" "}
            <StyledTextLink
              href="https://console.cron-job.org/settings"
              target="_blank"
              rel="noreferrer"
            >
              Cron-job.org
            </StyledTextLink>
          </Typography>
          <TextField
            required
            fullWidth
            type="password"
            name="cronApiKey"
            variant="outlined"
            id="cronApiKeyField"
            label="Cron Job API Key"
            placeholder="Enter your API key here"
            disabled={processing}
            autoComplete="off"
            value={enteredApiKey}
            onChange={(e) => setEnteredApiKey(e.target.value)}
          />
        </StyledCronSetupModalContent>
      </GModal>
    </Card>
  );
};

export default CronSetupDetails;
